export default __webpack_public_path__ + "static/media/dropdown-arrow-down-dark.f02279be.svg";